import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import { FiMail, FiLock, FiEye, FiEyeOff, FiArrowRight, FiUser } from 'react-icons/fi';
import './Login.css';

export default function Login() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deactivatedMsg, setDeactivatedMsg] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('reason') === 'deactivated') {
      setDeactivatedMsg('Your account has been deactivated. Please contact the administrator.');
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      toast.success('Welcome back!');
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      {/* Left panel */}
      <div className="login-left">
        <div className="login-logo">
          <img src="/cmpy_logo.png" alt="Creative Glass Tec" />
        </div>
        <div className="login-hero">
          <h2>Design. Plan.<br />Execute.</h2>
          <p>The complete interior design management platform for modern design teams.</p>
        </div>
        <div className="login-features">
          {['Project & Client Management', 'Role-Based Access Control', 'Real-time Collaboration', 'Finance & Payments'].map(f => (
            <div key={f} className="login-feature-item">
              <span className="login-feature-dot" />
              {f}
            </div>
          ))}
        </div>
        <div className="login-left-footer">© {new Date().getFullYear()} Creative Glass Tec. All rights reserved.</div>
      </div>

      {/* Right panel */}
      <div className="login-right">
        <div className="login-form-wrap">
          <div className="login-form-header">
            <div className="login-form-avatar login-form-avatar-icon"><FiUser /></div>
            <div className="login-form-avatar login-form-avatar-logo">
              <img src="/cmpy_logo.png" alt="Creative Glass Tec" />
            </div>
            <h1>Welcome back</h1>
            <p>Sign in to your account to continue</p>
          </div>

          {deactivatedMsg && (
            <div style={{ background: '#fff1f2', border: '1.5px solid #fecdd3', color: '#be123c', borderRadius: 10, padding: '0.75rem 1rem', fontSize: '0.875rem', fontWeight: 600, marginBottom: '1rem', lineHeight: 1.5 }}>
              🚫 {deactivatedMsg}
            </div>
          )}

          <form onSubmit={handleSubmit} className="login-form">
            <div className="login-field">
              <label>Email address</label>
              <div className="login-input-wrap">
                <FiMail className="login-input-icon" />
                <input
                  type="email"
                  value={form.email}
                  onChange={e => setForm({ ...form, email: e.target.value })}
                  placeholder="your@email.com"
                  required
                />
              </div>
            </div>

            <div className="login-field">
              <label>Password</label>
              <div className="login-input-wrap">
                <FiLock className="login-input-icon" />
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={form.password}
                  onChange={e => setForm({ ...form, password: e.target.value })}
                  placeholder="••••••••"
                  required
                />
                <button type="button" className="login-eye-btn" onClick={() => setShowPassword(p => !p)}>
                  {showPassword ? <FiEyeOff /> : <FiEye />}
                </button>
              </div>
            </div>

            <button type="submit" className="login-submit-btn" disabled={loading}>
              {loading ? (
                <span className="login-spinner" />
              ) : (
                <>Sign In <FiArrowRight /></>
              )}
            </button>
          </form>

          {/* <p className="login-footer-link">
            Don't have an account? <Link to="/register">Create one</Link>
          </p> */}
        </div>
      </div>
    </div>
  );
}